'use strict';
var inputs = document.querySelectorAll('form input');
inputs.forEach(function(input) {
    var label = document.createElement('label');
    label.classList.add('field-label');
    if (!input.id) input.id = input.name;
    label.htmlFor = input.id;
    label.textContent = input.name;
    var placeholder = input.name[0].toUpperCase() + input.name.slice(1);
    input.placeholder = placeholder;
    input.parentElement.prepend(label);
});

//# sourceMappingURL=js_task_fix_form_DOM.2159bfaf.js.map
